import isBrowser from 'is-browser';
import React from 'react';

/**
 * A universal effect that runs like useEffect on CSR,
 * and synchronously once during SSR render.
 */
export function useUniversalEffect(
  effect: React.EffectCallback,
  deps?: React.DependencyList
): void {
  const hasRunOnServerRef = React.useRef(false);

  // Regular client-side effect
  React.useEffect(effect, deps);

  // On the server, run only once per component instance
  if (!isBrowser && !hasRunOnServerRef.current) {
    hasRunOnServerRef.current = true;
    effect();
  }
}
